import Util from '@/lib/util'
import _ from "lodash";

export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
        align:"center"
      },
    {
        title:Util.L('Tên cấu hình'),
        key:'name',
    },{
        title:Util.L('SL sản phẩm'),
        key:'shortName',
        width: 120,
        align:"right",
        render:(h:any,params:any)=> { return h("span", _.size(params.row.warrantyDurationConfigs)); }
    },
    {
        title: Util.L('Action'),
        width:150,
        fixed:'right',
        slot: 'action',
        align: 'center'
    }]